// PracticePage.js
import React, { useEffect, useState, useContext } from "react";
import PracticeCard from "../components/PracticeCard.js";
import { AppContext } from "../AppContext.js";

const PracticePage = () => {
  const [practiceTests, setPracticeTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Thêm state để quản lý lớp được chọn
  const [selectedGrade, setSelectedGrade] = useState("all");

  const { fetchPractices } = useContext(AppContext);

  useEffect(() => {
    const getPracticeData = async () => {
      try {
        setLoading(true);
        const data = await fetchPractices();
        setPracticeTests(data);
        setError(null);
      } catch (err) {
        console.error("Lỗi khi tải bộ đề luyện thi:", err);
        setError("Không thể tải danh sách bộ đề. Vui lòng thử lại sau.");
      } finally {
        setLoading(false);
      }
    };
    getPracticeData();
  }, [fetchPractices]);

  // Logic lọc dữ liệu dựa trên lớp đã chọn
  const filteredPracticeTests =
    selectedGrade === "all"
      ? practiceTests
      : practiceTests.filter(
          (practice) => parseInt(practice.grade) === parseInt(selectedGrade)
        );

  return (
    <div className="container mx-auto px-4 py-12">
      <h2 className="text-4xl font-extrabold text-gray-900 text-center mb-6 leading-tight">
        Danh sách bộ đề luyện thi
      </h2>

      {/* Bộ lọc theo lớp, giống như TopicPage.js */}
      <div className="flex justify-center mb-6">
        <select
          value={selectedGrade}
          onChange={(e) => setSelectedGrade(e.target.value)}
          className="px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="all">Tất cả các lớp</option>
          <option value="6">Lớp 6</option>
          <option value="7">Lớp 7</option>
          <option value="8">Lớp 8</option>
          <option value="9">Lớp 9</option>
        </select>
      </div>

      {loading ? (
        <div className="text-center py-20">
          <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-blue-600 mx-auto mb-5"></div>
          <p className="text-2xl text-gray-700">Đang tải danh sách bộ đề...</p>
        </div>
      ) : error ? (
        <div className="text-center py-20">
          <p className="text-2xl text-red-600 font-semibold">
            Lỗi khi tải bộ đề luyện thi
          </p>
          <p className="text-lg text-gray-600 mt-3">Có lỗi xảy ra: {error}</p>
          <p className="text-gray-600 mt-2">Vui lòng thử lại sau.</p>
        </div>
      ) : filteredPracticeTests.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {/* Sử dụng danh sách đã được lọc */}
          {filteredPracticeTests.map((practice) => (
            <PracticeCard key={practice.id} practice={practice} />
          ))}
        </div>
      ) : (
        <div className="text-center py-20">
          <p className="text-2xl text-gray-700">
            Chưa có bộ đề nào cho lớp đã chọn.
          </p>
        </div>
      )}
    </div>
  );
};

export default PracticePage;
